import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { traderSiteSchema } from './getTraderSites';
import { userSchema } from '../user/getUsers';

export const representativeSchema = baseObjectSchema.extend({
  code: z.string(),
  name: z.string().optional(),
  companyId: z.string(),
  erpName: z.string().optional(),
  serverAddress: z.string().optional(),
  serverPort: z.string().optional(),
  traderId: z.string(),
  trader: z
    .object({
      id: z.string(),
      code: z.string().optional(),
      name: z.string().optional(),
      taxNumber: z.string().optional(),
    })
    .optional(),
  company: z
    .object({
      id: z.string(),
      code: z.string().optional(),
      name: z.string().optional(),
    })
    .optional(),
  windowsAuthentication: z.boolean().optional(),
  dbName: z.string().optional(),
  dbUsername: z.string().optional(),
  dbPassword: z.string().optional(),
});

export const getRepresentativesWithConditionsSchema = z.array(representativeSchema);

export type GetRepresentativesResponse = z.infer<typeof getRepresentativesWithConditionsSchema>;

export const getRepresentativesByIDSchema = representativeSchema.extend({
  defaultTraderSiteId: z.string().optional(),
  defaultTraderSite: traderSiteSchema.optional(),
  createUser: userSchema.optional(),
  updateUser: userSchema.optional(),
});

export type GetRepresentativesByIDResponse = z.infer<typeof getRepresentativesByIDSchema>;
